<div class="tiles-container">
    <div class="breadcrumb-container">
        <nav class="breadcrumb">
            <a routerLink="/user/region">Region</a>
            <span class="separator">/</span>
            <a>Modules Category</a>
        </nav>
    </div>
    <div class="tiles-wrapper">
        <div class="tiles-row">
            <div class="tile-card split-tile" (click)="selectOrg('QHSE - Management')">
                <div class="tile-image">
                    <img src="assets/images/qhse.png" alt="QHSE Management">
                </div>
                <div class="tile-details">
                    <h3>QHSE - Management</h3>
                    <p>View and manage all QHSE Management-related documents,</p>
                    <p>policies, and standards.</p>
                    <h3 class="tile-footer">You have {{ managementCount }} Documents in QHSE - Management for Review
                    </h3>
                </div>
            </div>
            <div class="tile-card split-tile" (click)="selectOrg('QHSE - Operations')">
                <div class="tile-image">
                    <img src="assets/images/qhse-operations.jpg" alt="QHSE Operations">
                </div>
                <div class="tile-details">
                    <h3>QHSE - Operations</h3>
                    <p>Access QHSE Operations processes, SOPs, and related</p>
                    <p>operational documentation.</p>
                    <h3 class="tile-footer">You have {{ operationsCount }} Documents in QHSE - Operations for Review</h3>
                </div>
            </div>
        </div>
    </div>

</div>